import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Box,
} from "@mui/material";

function SimilarListingCard({ img }) {
  return (
    <Card
      sx={{
        width: 254,
        minHeight: 335,
        boxShadow:
          "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        borderRadius: "8px",
      }}
    >
      <CardMedia component="img" height="155" image={img} alt="Machine" />
      <CardContent sx={{ padding: "16px !important" }}>
        <Typography
          variant="subtitle1"
          component="div"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "600",
          }}
        >
          Caterpillar 988f wheel loaders/integrated tools carriers 70 Characters
        </Typography>
        <Box sx={{ display: "flex", columnGap: "16px", marginTop: "16px" }}>
          <Box sx={{ width: "103px" }}>
            <Typography
              variant="body2"
              color="#616161"
              sx={{ fontSize: "14px", lineHeight: "20px" }}
            >
              Year
            </Typography>
            <Typography
              variant="body2"
              color="#616161"
              sx={{ fontSize: "14px", lineHeight: "20px" }}
            >
              Hours
            </Typography>
            <Typography
              variant="body2"
              color="#616161"
              sx={{ fontSize: "14px", lineHeight: "20px" }}
            >
              Condition
            </Typography>
          </Box>
          <Box sx={{ width: "103px" }}>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{ fontWeight: "600", fontSize: "14px", lineHeight: "20px" }}
            >
              2,000
            </Typography>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{ fontWeight: "600", fontSize: "14px", lineHeight: "20px" }}
            >
              295,000
            </Typography>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{ fontSize: "14px", fontWeight: "600", lineHeight: "20px" }}
            >
              Used
            </Typography>
          </Box>
        </Box>
      </CardContent>
      {/* <CardActions>
        <Button size="small">Share</Button>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
  );
}

export default SimilarListingCard;
